import { cashInCashOutTypes } from "../../components/modules/income/DeclaredIncome/shared/constants/cashInCashOutTypes";

export const PatchAddBorrowerCashInCashOutMethod = {
  dehydrate(data) {
    if (!data.participant.onboardingDetails?.user_details?.document_id) {
      throw new Error("Participant user details document id is required");
    }

    return {
      op: "processPatchAddBorrowerCashInCashOutMethod",
      id: data.participant.participantId,
      cash_in_cash_out_method_id: data.cashInCashOutMethodId,
      type: data.type ? data.type : cashInCashOutTypes.BANK_ACCOUNT_TYPE,
      account_holder_first_name:
        data.participant.onboardingDetails.user_details.document_id.full_name
          .first_name,
      account_holder_last_name:
        data.participant.onboardingDetails.user_details.document_id.full_name
          .last_name,
      account_holder_code: data.bankAccountIBAN,
      account_holder_account_participation_level: "owner",
      description: "-",
    };
  },
};
